module.exports = __webpack_public_path__ + "static/media/03-schuhe_brille.3cb9cd0d.jpg";